export enum StowageRulePropertyLocation {
    NA,
    Tank,
    AdjacentTank,
}
